var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapChart Chart",attrs:{"id":"mapChart"},on:{"dblclick":_vm.returnDbClickFn}})
}
var staticRenderFns = []

export { render, staticRenderFns }